var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFood = function SvgFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dish"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M15.6698 25.0808C20.8632 25.0808 25.0733 20.8708 25.0733 15.6774C25.0733 10.484 20.8632 6.27393 15.6698 6.27393C10.4764 6.27393 6.26636 10.484 6.26636 15.6774C6.26636 20.8708 10.4764 25.0808 15.6698 25.0808Z",
    fill: "#FFB863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M15.6698 21.6614C18.9747 21.6614 21.6538 18.9823 21.6538 15.6774C21.6538 12.3725 18.9747 9.69336 15.6698 9.69336C12.3649 9.69336 9.68579 12.3725 9.68579 15.6774C9.68579 18.9823 12.3649 21.6614 15.6698 21.6614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "spoon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M29.6436 6.3761H28.6436V25.1656H29.6436V6.3761Z",
    fill: "#430301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    d: "M29.0909 10.5482C30.8205 10.5482 32.2225 8.34499 32.2225 5.62717C32.2225 2.90935 30.8205 0.706116 29.0909 0.706116C27.3614 0.706116 25.9594 2.90935 25.9594 5.62717C25.9594 8.34499 27.3614 10.5482 29.0909 10.5482Z",
    fill: "#BC4B0F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "fork"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M3.32336 6.3761H2.32336V25.1656H3.32336V6.3761Z",
    fill: "#430301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416748 9.69337V1.99963H1.31148L1.31075 7.90363H2.32275L2.32336 1.99963H3.2181L3.21775 7.90363H4.11275L4.11283 1.99963H5.00757V9.69337H0.416748Z",
    fill: "#BC4B0F"
  })))));
};
export default SvgFood;